<div class="cgu-main-container" >
    <div class="cgu-sub-container">
        <div class="cgu-content" *ngIf="template">
            <ng-container *ngIf="template==='MAIN'">
                <h1 class="title" [innerHtml]="'CGU_OVERLAY_TITLE_UPLOADER' | translate | safeHtml"></h1>
                <h2 class="description" [innerHtml]="'CGU_OVERLAY_DESCRIPTION_UPLOADER_NOTSUPPORTED' | translate:{link_about: linkAboutTemplate, link_api: linkAPITemplate} | safeHtml"></h2>

            </ng-container>
            <ng-container *ngIf="template==='VIEWER'">
                <h1 class="title" translate>CGU_OVERLAY_TITLE_VIEWER</h1>
                <h2 class="description" [innerHtml]="'CGU_OVERLAY_DESCRIPTION_VIEWER' | translate:{link_about: linkAboutTemplate, link_api: linkAPITemplate} | safeHtml"></h2>
            </ng-container>

            <div class="cta-container">
                <button class="btn-v3 red cta-link" (click)='acceptCGU()' translate>CGU_OVERLAY_BUTTON_ACCEPT</button>
                <button class="btn-v3 dark-filaire link-about" [innerHtml]="linkAboutTemplate | safeHtml"></button>
                <!-- Warning, id for GTM click are handled in .ts -->
            </div>
        </div>
    </div>
</div>